import React from 'react';

import { type TButtonBlock } from '@wp-block-builder/blocks/Button';
import { generateRandomBlockId } from '@wp-block-builder/package';

import BlockTypeIcon from '../../../../../blocks/helpers/BlockTypeIcon';
import { type TBlock } from '../../../../../blocks/types';

import defineBlockButton from './helpers/defineBlockButton';

const getDefaultProps = (props: { props?: Record<string, unknown>; style?: TBlock['style'] } = {}): TButtonBlock => ({
  id: generateRandomBlockId(),
  type: 'Button',
  style: {
    fontFamily: 'inherit',
    fontSize: '16px',
    fontWeight: 'bold',
    padding: '16px 24px 16px 24px',
    textAlign: 'center',
    ...props.style,
  },
  props: {
    buttonBackgroundColor: null,
    buttonStyle: 'rounded',
    buttonTextColor: null,
    fullWidth: false,
    size: 'medium',
    text: 'Button',
    url: 'https://www.usewaypoint.com',
    ...props.props,
  },
  sectionProps: {},
});

export default defineBlockButton<TButtonBlock>({
  label: 'Button',
  icon: <BlockTypeIcon type="Button" />,
  defaultBlock: () => getDefaultProps(),
  defaultContainerBlock: () => getDefaultProps({ style: { padding: '16px 0px 16px 0px' } }),
  defaultColumnBlock: () =>
    getDefaultProps({
      props: { fullWidth: true },
      style: { padding: '0px 0px 0px 0px' },
    }),
});
